const electricianDetailedRateCard = {
  key: "electrician",
  title: "Electrician Detailed Rate Card",
  note:
    "Indicative electrical pricing. Final charge may vary based on concealed wiring, load condition, material brand, ladder/height needs, and emergency or after-hours handling.",
  sections: [
    {
      title: "Switches & Sockets",
      items: [
        { name: "Switch repair", price: "₹149 per point" },
        { name: "Socket repair", price: "₹149 per point" },
        { name: "Switch / socket replacement", price: "₹199 per point" },
        { name: "Switchboard fitting", price: "₹249 onwards" },
      ],
    },
    {
      title: "Lights & Fans",
      items: [
        { name: "Bulb / holder installation", price: "₹99 per point" },
        { name: "Tube light / batten light fitting", price: "₹149 per point" },
        { name: "Ceiling fan installation", price: "₹249 per fan" },
        { name: "Fan removal", price: "₹149 per fan" },
        { name: "Fan regulator replacement", price: "₹149 per unit" },
      ],
    },
    {
      title: "Safety & Wiring",
      items: [
        { name: "MCB / fuse inspection", price: "₹249 visit" },
        { name: "MCB replacement support", price: "₹299 onwards" },
        { name: "Visible wiring correction", price: "₹199 onwards" },
        { name: "Wiring inspection", price: "₹299 visit" },
      ],
    },
    {
      title: "Accessories",
      items: [
        { name: "Doorbell installation", price: "₹149 per unit" },
        { name: "Exhaust fan installation", price: "₹249 per unit" },
        { name: "Small appliance electrical check", price: "₹249 visit" },
      ],
    },
  ],
};

export default electricianDetailedRateCard;